import { r as react } from './index-ae8bfcfb.js';

var LocaleContext = /*#__PURE__*/react.createContext(undefined);

export { LocaleContext as L };
